/**
 * KPISelectorCell - KPI指标选择器组件
 */
import React from 'react';
import { Select } from 'antd';
import { KPIDimension } from '../../../../services/kpiSettingsService';
import { getAllowedCategories, CATEGORY_MAP } from './constants';

interface KPISelectorCellProps {
    deptId: number;
    deptName: string;
    kpiField: string;
    value: number | undefined;
    dimensions: KPIDimension[];
    onChange: (deptId: number, field: string, value: any) => void;
}

export const KPISelectorCell: React.FC<KPISelectorCellProps> = ({
    deptId, deptName, kpiField, value, dimensions, onChange
}) => {
    const allowedCategories = getAllowedCategories(deptName);

    // 按分类分组
    const groupedDimensions: { [key: string]: KPIDimension[] } = {};
    dimensions.filter(d => d.is_active).forEach(d => {
        if (allowedCategories && d.category && !allowedCategories.includes(d.category)) {
            return;
        }
        let category = d.category_display || (d.category ? CATEGORY_MAP[d.category] : null) || '未分类';
        if (!groupedDimensions[category]) {
            groupedDimensions[category] = [];
        }
        groupedDimensions[category].push(d);
    });

    const categories = Object.keys(groupedDimensions).sort();

    return (
        <Select
            style={{ width: 140 }}
            value={value}
            onChange={v => onChange(deptId, kpiField, v)}
            allowClear
            placeholder="选择指标"
            size="small"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => {
                if (!option || option.options) return false;
                return String(option.children).toLowerCase().includes(input.toLowerCase());
            }}
        >
            {categories.map(category => (
                <Select.OptGroup key={category} label={category}>
                    {groupedDimensions[category].map(d => (
                        <Select.Option key={d.id} value={d.id}>{d.name}</Select.Option>
                    ))}
                </Select.OptGroup>
            ))}
        </Select>
    );
};
